import React, { useEffect, useMemo, useRef } from 'react';
import mediaQuery from '../../../../../helpers/mediaQuery';
import { INPUT_ELEMENT_ID } from '../components/input/input';
import useResizeListener from './useResizeListener';

function useHoverOutside(open: boolean, setOpen: React.Dispatch<React.SetStateAction<boolean>>): void {
  const { innerWidth } = useResizeListener();
  const isXLargeUp = useMemo(() => mediaQuery.isXLargeUp(), [innerWidth]);
  const hoveredElementRef = useRef<Element>();
  const inputElement = document.getElementById(INPUT_ELEMENT_ID);

  const handleHoverOutside = (e: Event) => {
    const isHoverOnOpenableMenuItem = (e.target as Element).closest('.main-menu__item--has-children');
    if (isHoverOnOpenableMenuItem) {
      setTimeout(() => {
        if (e.target === hoveredElementRef.current) {
          setOpen(false);
          inputElement?.blur();
        }
      }, 300);
    }
    hoveredElementRef.current = e.target as Element;
  };

  useEffect(() => {
    if (open && isXLargeUp) {
      document.addEventListener('mouseover', handleHoverOutside);
    }
    return () => {
      if (open && isXLargeUp) {
        document.removeEventListener('mouseover', handleHoverOutside);
      }
    };
  }, [open, isXLargeUp]);
}

export default useHoverOutside;
